import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import vSelect from 'vue-select';
import ConfirmChange from './confirm-change';

export default Vue.component('site-options', {
  template: require('./template.html'),
  name: 'site-options',
  components: {
    vSelect,
    ConfirmChange,
  },
  computed: {
    ...mapGetters(['currentSite', 'priceSource', 'currentUser']),
    planPrice() {
      return this.currentSite.exempt ? '0 (exempt)' : this.currentSite.planPrice || 0;
    },
    canUpdateHosting() {
      return this.hosting !== this.initialHosting;
    },
    plans() {
      const planOptions = [];
      if (this._isBundle) {
        planOptions.push('Premium');
      } else {
        _.forOwn(this.priceSource.tiers, (value, key) => {
          planOptions.push(key);
        });
      }
      return planOptions;
    },
  },
  data() {
    return {
      loading: false,
      optionsErrors: [],
      selectedPlan: null,
      initialHosting: false,
      hosting: false,
    };
  },
  watch: {
    'currentSite.tier': function setTier(tier) {
      this.selectedPlan = tier;
    },
  },
  created() {
    this.selectedPlan = this.currentSite.tier;
    const discount = (this.currentSite.discount && this.currentSite.discount.hosting) || false;
    this.setInitialHosting(discount);
  },
  methods: {
    runValidator(e) {
      this.optionsErrors = [];
      if (!e) {
        this.optionsErrors = ['Plan option required.'];
      }
    },
    changePlan(e) {
      this.runValidator(e);
    },
    formatErrors(ers) {
      return ers.join(' ');
    },
    setInitialHosting(val) {
      this.initialHosting = val;
      this.hosting = val;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/websites/edit-site/options/index.js